import { cloneDeep } from "lodash";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSetRecoilState } from "recoil";
import { errorState } from "../../../recoil/error/atom";
import IR330CDeclaration from "./IR330CDeclaration";
import IR330CFooter from "./IR330CFooter";
import IR330CPageIntro from "./IR330CPageIntro";
import IR330CPageTitle from "./IR330CPageTitle";
import IR330CPersonName from "./IR330CPersonName";
import IR330CPrivacyNote from "./IR330CPrivacyNote";
import IR330CTaxCode from "./IR330CTaxCode";
import IR330Header from "./IR330Header";
import IR330CFormEnd from "./IR330CFormEnd";
import validateDate from "../common/ValidationHelper";
import Button from "react-bootstrap/Button";
const IR330C = (props) => {
  const popError = useSetRecoilState(errorState);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const [taxCode, setTaxCode] = useState("");
  const [day1, setDay1] = useState("");
  const [day2, setDay2] = useState("");
  const [month1, setMonth1] = useState("");
  const [month2, setMonth2] = useState("");

  const [year3, setYear3] = useState("");
  const [year4, setYear4] = useState("");
  const [signature, setSignature] = useState("");
  const [iRDs, setIRDs] = useState(new Array(9).fill(""));

  const setSignatureData = (data) => {
    setSignature(data);
  };
  const setDateData = ({ name, value }) => {
    switch (name) {
      case "day1":
        setDay1(value);
        break;
      case "day2":
        setDay2(value);
        break;
      case "month1":
        setMonth1(value);
        break;
      case "month2":
        setMonth2(value);
        break;
      case "year3":
        setYear3(value);
        break;
      case "year4":
        setYear4(value);
        break;
      default:
        break;
    }
  };

  const setNameAndTaxCode = ({ name, value }) => {
    switch (name) {
      case "firstName":
        setFirstName(value);
        break;
      case "surName":
        setLastName(value);
        break;
      case "taxCode":
        setTaxCode(value);
        break;
      default:
        break;
    }
  };

  const setIRDData = ({ name, value }) => {
    const index = parseInt(name.replace("IRD", ""), 10);
    let newCopyiRDs = cloneDeep(iRDs);
    newCopyiRDs[index - 1] = value;
    setIRDs(newCopyiRDs);
  };

  const resetForm = () => {
    setIRDs(new Array(9).fill(""));
    const value = "";
    setDay1(value);
    setDay2(value);
    setMonth1(value);
    setMonth2(value);
    setYear3(value);
    setYear4(value);
    setFirstName(value);
    setLastName(value);
    setTaxCode(value);
    setSignature(value);
  };

  const isRequiredFieldsProvided = (formData) => {
    return (
      firstName &&
      lastName &&
      formData.IRDNumber.trim() !== "" &&
      taxCode &&
      formData.day &&
      formData.month &&
      formData.year &&
      signature
    );
  };

  const validateForm = (formData) => {
    const isRequiredFields = isRequiredFieldsProvided(formData);
    if (isRequiredFields) {
      const isValidDate = validateDate(formData.day, formData.month, formData.year);
      if (!isValidDate) {
        return { isValid: false, message: "Signature date is invalid. Enter date in DD/MM/YY format e.g. 27/05/25" };
      }
      return { isValid: true, message: "" };
    }
    return { isValid: false, message: "All fields are mandatory." };
  };

  const submitForm = () => {
    const data = {
      interactiveDocument: "IR330C",
      firstName,
      surName: lastName,
      IRDNumber: iRDs.join(""),
      taxCode,
      day: day1 + day2,
      month: month1 + month2,
      year: year3 + year4,
      signatureContent: signature,
    };

    const { isValid, message } = validateForm(data);
    if (isValid) {
      props.submit(data).then((result) => {
        if (result) {
          props.redirectToList();
        }
      });
    } else {
      popError([
        {
          type: "warning",
          title: "Warning",
          message: message,
        },
      ]);
    }
  };

  return (
    <div className="row" style={{ marginTop: "20px" }}>
      <div className="container" style={{ paddingBottom: "5px", boxShadow: "2px 2px 2px 2px rgb(0 0 0 / 20%)" }}>
        <IR330Header />
        <div className="container">
          <IR330CPageTitle />
          <div className="row">
            <IR330CPageIntro />
            {/* <!--once-completed-box end--> */}
            <IR330CPersonName
              setNameData={setNameAndTaxCode}
              firstName={firstName}
              surName={lastName}
              IRD={iRDs}
              setIRDData={setIRDData}
            />
            {/* <!--1 Your details end--> */}
            <IR330CTaxCode setTaxCode={setNameAndTaxCode} taxCode={taxCode} />
            {/* <!--2 Your tax code end--> */}
            <IR330CDeclaration
              setDateData={setDateData}
              setSignatureData={setSignatureData}
              day1={day1}
              day2={day2}
              month1={month1}
              month2={month2}
              year3={year3}
              year4={year4}
              signature={signature}
            />
            <IR330CFormEnd />
            <IR330CPrivacyNote />
            <div className="reset-form-btn">
              <Button type="button" onClick={resetForm}>
                RESET FORM
              </Button>
              &nbsp;&nbsp;
              <Button type="button" onClick={submitForm}>
                SUBMIT FORM
              </Button>
            </div>
          </div>
          <div className="pagebreak" />
          <IR330CFooter />
        </div>
      </div>
    </div>
  );
};

IR330C.propTypes = {
  submit: PropTypes.func.isRequired,
};
export default IR330C;
